import React, { FC } from 'react';
import { TextInput } from 'components/forms';
import { FieldRenderProps } from 'react-final-form';

export interface ITextInputWrapper extends FieldRenderProps<string> {
  label: string;
  errorClassname?: string;
}

const TextInputWrapper: FC<ITextInputWrapper> = (props) => {
  const { input, meta, render, children, ...otherProps } = props;

  return <TextInput {...input} {...meta} {...otherProps} />;
};

export default TextInputWrapper;
